import React from "react";
import Modal from "./Modal";

const ClaimAllModal = ({ isVisible, onCancel, onClaim, claimAmount }) => {
  const handleClaim = () => {
    onCancel();
    onClaim();
  };

  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="disconnect-modal card px-3 py-4"
    >
      <div className="heading">
        <h4 className="mb-1">Claim $GBET</h4>
        <p className="text pt-3">
          Do you want to claim <strong>{claimAmount}</strong> $GBET to your wallet?
        </p>
        <div className="body d-flex justify-content-center pt-4   mb-0">
          <button
            className="btn btn-primary mx-2 continue"
            onClick={handleClaim}
          >
            Yes
          </button>
          <button
            className="btn btn-outline-secondary  me-5 close"
            onClick={onCancel}
          >
            No
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ClaimAllModal;
